/* kz-wishlist.js - localStorage wishlist + "save for later" (no app).
   Storage key kz_wishlist = JSON array of product handles. Pages: /pages/wishlist, cart "Saved for later". */
(function () {
  var KEY = 'kz_wishlist';
  var HEART = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  function read() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} document.dispatchEvent(new CustomEvent('kz:wishlist')); }
  function has(h) { return read().indexOf(h) > -1; }
  function add(h) { var a = read(); if (a.indexOf(h) < 0) { a.unshift(h); write(a); } }
  function remove(h) { write(read().filter(function (x) { return x !== h; })); }
  function toggle(h) { if (has(h)) remove(h); else add(h); }
  function handleFromHref(href) { var m = (href || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---- hearts on cards + product page ---- */
  function heartBtn(h, cls) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'kz-heart ' + (cls || ''); b.setAttribute('data-kz-heart', h);
    b.setAttribute('aria-label', 'Save to wishlist'); b.innerHTML = HEART;
    if (has(h)) b.classList.add('is-on');
    return b;
  }
  function decorate() {
    document.querySelectorAll('.card-wrapper:not([data-kz-h])').forEach(function (w) {
      var a = w.querySelector('a[href*="/products/"]'); var h = a && handleFromHref(a.getAttribute('href'));
      w.setAttribute('data-kz-h', h || '');
      if (!h) return;
      var host = w; if (getComputedStyle(w).position === 'static') w.style.position = 'relative';
      host.appendChild(heartBtn(h, 'kz-heart--card'));
    });
    var t = document.querySelector('.product__title:not([data-kz-h])');
    if (t) {
      var ph = handleFromHref(location.pathname); t.setAttribute('data-kz-h', ph || '');
      if (ph) { var b = heartBtn(ph, 'kz-heart--pdp'); b.insertAdjacentHTML('beforeend', '<span class="kz-heart__label">Save</span>'); t.appendChild(b); }
    }
    var cart = document.getElementById('cart-icon-bubble');
    if (cart && !document.querySelector('.kz-wish-link')) {
      var l = document.createElement('a'); l.href = '/pages/wishlist'; l.className = 'header__icon kz-wish-link link focus-inset';
      l.setAttribute('aria-label', 'Wishlist'); l.innerHTML = HEART + '<span class="kz-wish-count" hidden></span>';
      cart.parentNode.insertBefore(l, cart);
    }
    refresh();
  }
  function refresh() {
    var n = read().length;
    document.querySelectorAll('.kz-wish-count').forEach(function (c) { if (c.textContent !== String(n)) c.textContent = n; c.hidden = !n; });
    document.querySelectorAll('[data-kz-heart]').forEach(function (b) { b.classList.toggle('is-on', has(b.getAttribute('data-kz-heart'))); });
  }

  /* ---- grids: wishlist page + cart "saved for later" ---- */
  var cache = {};
  function getProduct(h) {
    if (cache[h]) return cache[h];
    cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[h];
  }
  function renderGrids() {
    document.querySelectorAll('[data-kz-grid]').forEach(function (box) {
      var list = read(); var empty = box.getAttribute('data-empty') || '';
      var wrap = box.closest('[data-kz-grid-wrap]');
      if (!list.length) { box.innerHTML = empty ? '<p class="kz-grid__empty">' + empty + '</p>' : ''; if (wrap && !empty) wrap.hidden = true; return; }
      if (wrap) wrap.hidden = false;
      Promise.all(list.map(getProduct)).then(function (ps) {
        box.innerHTML = ps.filter(Boolean).map(function (p) {
          var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
          return '<div class="kz-grid__card"><a href="' + p.url + '" class="kz-grid__img">' + (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" width="400">' : '') + '</a>' +
            '<a href="' + p.url + '" class="kz-grid__title">' + esc(p.title) + '</a>' +
            '<p class="kz-grid__price">From ' + money(p.price) + '</p>' +
            '<div class="kz-grid__actions"><a class="button button--secondary" href="' + p.url + '">Choose options</a>' +
            '<button type="button" class="kz-grid__remove" data-kz-remove="' + esc(p.handle) + '">Remove</button></div></div>';
        }).join('');
      });
    });
  }

  /* ---- events ---- */
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var hb = t.closest('[data-kz-heart]');
    if (hb) { e.preventDefault(); e.stopPropagation(); toggle(hb.getAttribute('data-kz-heart')); return; }
    var rm = t.closest('[data-kz-remove]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-kz-remove')); return; }
    var sv = t.closest('[data-kz-save]');
    if (sv) {
      e.preventDefault(); add(sv.getAttribute('data-kz-save')); sv.disabled = true; sv.textContent = 'Saved';
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: parseInt(sv.getAttribute('data-line'), 10), quantity: 0 }) })
        .then(function () { location.reload(); });
    }
  }, true);
  document.addEventListener('kz:wishlist', function () { refresh(); renderGrids(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { refresh(); renderGrids(); } });

  var pending = false;
  function init() {
    decorate(); renderGrids();
    new MutationObserver(function (muts) {
      if (pending) return;
      var relevant = muts.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && !(n.classList && (n.classList.contains('kz-heart') || n.classList.contains('kz-wish-link'))) &&
            (n.matches('.card-wrapper, .product__title, #cart-icon-bubble') || n.querySelector('.card-wrapper, .product__title, #cart-icon-bubble'));
        });
      });
      if (!relevant) return;
      pending = true; setTimeout(function () { pending = false; decorate(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
